export default __webpack_public_path__ + "static/UChicago-logo-maroon-15e036cb3f3e8f10da8952ed2719948b.svg";